
































import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'ChemUCI51LC_Task84',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data: function (): any {
    return {
      inputs: {
        studentAnswer: null,
      },
      options: [
        {
          img: prefixPublicAsset('/img/assignments/uciTask84_optionA.png'),
          value: 'A',
        },
        {
          img: prefixPublicAsset('/img/assignments/uciTask84_optionB.png'),
          value: 'B',
        },
        {
          img: prefixPublicAsset('/img/assignments/uciTask84_optionC.png'),
          value: 'C',
        },
        {
          img: prefixPublicAsset('/img/assignments/uciTask84_optionD.png'),
          value: 'D',
        },
      ],
    };
  },
};
